import axios from 'axios';
import camelcaseKeys from 'camelcase-keys-recursive';
import snakecaseKeys from 'utils/SnakecaseKeys';
import qs from 'qs';

export default axios.create({
  baseURL: '/api/internal/',
  headers: {
    'X-Homie-Client': true,
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: params => {
    return qs.stringify(snakecaseKeys(params), { arrayFormat: 'brackets' });
  },
  transformRequest: [
    function(data) {
      if (!data) {
        return;
      }

      return snakecaseKeys(data);
    },
    ...axios.defaults.transformRequest
  ],
  transformResponse: [
    ...axios.defaults.transformResponse,
    function(data) {
      if (!data) {
        return;
      }
      return camelcaseKeys(data, { deep: true });
    }
  ]
});
